import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const DocumentUploadedDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => (
  <>
    <DetailsRow label="Date" value={date} />
    <DetailsRow
      label="Client ID"
      component={<LeadInfo leadId={data.leadId} />}
    />
    <DetailsRow label="Name" value={data.leadFullName} />
    <DetailsRow label="Document Name" value={data.documentName} />
  </>
);
